<div class="diversion-orders" *ngIf="diversionRoutes$ | async as diversionRoutes">
  <h2>Divert Order</h2>

  <form [formGroup]="diversionOrderForm" class="divert-orders-form" (ngSubmit)="divertFrac()">
    <div class="flex flex-col">
      <div class="form-field-label">
        Select Well
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="fracId">
          <mat-select-trigger>
            {{ diversionOrderForm.get('fracId').value?.fracName }}
          </mat-select-trigger>
          <mat-option
            *ngFor="let diversionRoute of diversionRoutes; trackBy: trackByFracId"
            [value]="diversionRoute"
            style="height: 96px !important; "
            [ngStyle]="{
              color: diversionRoute.totalStorageAmount - diversionRoute.totalVolumeInStorage > 0 ? 'black' : 'red'
            }"
          >
            <div style="font-size:1.1em; line-height: 1.5em">{{ diversionRoute.fracName }}</div>
            <div
              style="font-size:.9em; line-height: 1.5em; color: #5f9a7e"
              *ngIf="diversionRoute.totalStorageAmount - diversionRoute.totalVolumeInStorage > 0"
            >
              Room: {{ diversionRoute.totalStorageAmount - diversionRoute.totalVolumeInStorage | number }} lbs in ETA
              {{ diversionRoute.timeToReachWell }} min
            </div>
            <div
              style="font-size:.9em; line-height: 1.5em;"
              *ngIf="diversionRoute.totalStorageAmount - diversionRoute.totalVolumeInStorage <= 0"
            >
              No room
              <span *ngIf="diversionRoute.timeToReachWell > 0">in ETA {{ diversionRoute.timeToReachWell }} min</span>
            </div>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="diversionOrderForm.get('fracId').invalid">
          Please select a well
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <div class="form-field-label">
        Select Purchase Order
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="POId">
          <mat-option
            *ngFor="let purchaseOrder of purchaseOrders$$ | async; trackBy: trackByPOId"
            [value]="purchaseOrder.id"
          >
            {{ purchaseOrder.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="diversionOrderForm.get('POId').invalid">
          Please select a purchase order
        </mat-error>
      </mat-form-field>
    </div>

    <sa-network-active-button [active]="networkActive$ | async">
      <button mat-raised-button color="primary" [disabled]="diversionOrderForm.invalid">
        Divert
      </button>
    </sa-network-active-button>
  </form>
</div>
